import React from 'react';

const NotFound = () => <div>Route you are searching for doesn’t exist.</div>;

export default NotFound;
